import ankerSolix from "./power-stations/anker-solix";
import bluetti from "./power-stations/bluetti";
import djiPower from "./power-stations/dji-power";
import ecoflow from "./power-stations/ecoflow";
import goalZero from "./power-stations/goal-zero";
import jackery from "./power-stations/jackery";
import pecron from "./power-stations/pecron";

export default {
  "Anker Solix": ankerSolix,
  BLUETTI: bluetti,
  "DJI Power": djiPower,
  EcoFlow: ecoflow,
  "Goal Zero": goalZero,
  Jackery: jackery,
  Pecron: pecron,
};
